import { ActionTypes, RootStore } from './types';

type Dispatch<T> = (action: ActionTypes<T>) => void;

type DispatchFn<T> = (dispatch: StoreActions<T>) => void;

export interface StoreActions<T> {
  startLoading(params?: Record<string, unknown>): void;
  stopLoading(params?: Record<string, unknown>): void;
  setValue(data: T, params?: Record<string, unknown>): void;
  updateValue(data: T, propName: string): void;
  setError(error: string): void;
  reset(): void;
  dispatch(action: DispatchFn<T>): void;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export interface RootStoreActions<T> {
  wipeAll(initialState: RootStore): void;
}

export const createActions = <T>(key: string, dispatch: Dispatch<T>, initialValue?: T): StoreActions<T> => {
  return {
    dispatch: (action: DispatchFn<T>) => {
      action(createActions(key, dispatch));
    },
    startLoading: (params?: Record<string, unknown>) => {
      dispatch({
        type: '@STORE/START_LOADING',
        payload: {
          key,
          params,
        },
      });
    },

    stopLoading: (params?: Record<string, unknown>) => {
      dispatch({
        type: '@STORE/STOP_LOADING',
        payload: {
          key,
          params,
        },
      });
    },

    setValue: (data: T, params?: Record<string, unknown>) => {
      dispatch({
        type: '@STORE/SET_VALUE',
        payload: {
          key,
          data,
          params,
        },
      });
    },

    updateValue: (data: T, propName: string) => {
      dispatch({
        type: '@STORE/UPDATE_VALUE',
        payload: {
          key,
          data,
          propName,
        },
      });
    },

    setError: (error: string) => {
      dispatch({
        type: '@STORE/SET_ERROR',
        payload: {
          key,
          error,
        },
      });
    },
    reset: () => {
      dispatch({
        type: '@STORE/CLEAR',
        payload: {
          key,
          data: initialValue,
        },
      });
    },
  };
};

export const createRootActions = <T>(dispatch: Dispatch<T>): RootStoreActions<T> => {
  return {
    wipeAll: (initialState: RootStore) => {
      dispatch({
        type: '@STORE/WIPE',
        payload: {
          initialState,
        },
      });
    },
  };
};
